import {
    breakpointsTailwind,
    createSharedComposable,
    useBreakpoints,
    useMediaQuery
} from '@vueuse/core'

/**
 * Checks for common device sizes and touch-enabled screens.
 */
export const useDeviceType = createSharedComposable(() => {
    const breakpoints = useBreakpoints(breakpointsTailwind)

    const isMobile = breakpoints.smaller('md')

    const isTablet = breakpoints.greaterOrEqual('md')

    const isDesktop = breakpoints.greaterOrEqual('lg')

    const isLargeDesktop = breakpoints.greaterOrEqual('xl')

    const isVeryLargeDesktop = breakpoints.greaterOrEqual('2xl')

    const isTouchScreen = useMediaQuery('(hover: none)')

    return {
        isMobile,
        isTablet,
        isDesktop,
        isLargeDesktop,
        isVeryLargeDesktop,
        isTouchScreen
    }
})
